<template>
    <div class="searching-links side-padding">
        <h2>{{ content.title }}</h2>
        <p>{{ content.lead_in }}</p>
        <div class="img-links">
            <a :href="content.link_one_url">
                <img :src="getImage(content.link_one_img_url)" :alt="content.link_one_text">
                <span class="text h2">
                    <span>{{ content.link_one_text }}</span>
                </span>
            </a>
            <a :href="content.link_two_url">
                <img :src="getImage(content.link_two_img_url)" :alt="content.link_two_text">
                <span class="text h2">
                    <span>{{ content.link_two_text }}</span>
                </span>
            </a>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            'site': 'search/site'
        }),
        content () {
            return this.$i18n.messages[this.$i18n.locale].searching_for_more[this.site];
        }
    },
    methods: {
        getImage(path) {
            return require(`@/assets/${path}`);
        }
    }
}
</script>

<style scoped lang="scss">
$max-link-height: 400px;
.searching-links {
    margin-top: $s3;

    p {
        max-width: $max-text-width-small;
    }
    .img-links {
        max-height: $max-link-height;
        display: flex;
        justify-content: space-between;

        a {
            display: inline-block;
            position: relative;
            flex-basis: 49%;

            &:after {
                content: '';
                background: linear-gradient( 180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
                height: 100%;
                width: 100%;
                display: block;
                position: absolute;
                top: 0;
                left: 0;
            }

            img {
                object-fit: cover;
                height: 100%;
                width: 100%;
            }

            .text {
                z-index: 1;
                padding: 1rem 2.275rem;
                position: absolute;
                bottom: 0;
                left: 0;
                color: $white;
                height: 100%;
                width: 100%;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: flex-start;
                transition: background 250ms;
                margin-bottom: 0;

                span {
                    width: 50%;
                }

                
                &:hover {
                    background: rgba(0,0,0,.4);
                }

            }

            &:focus {
                outline-offset: 4px;
            }
        }
    }

    @media (max-width: $mq-max-width-desktop-sml) {

    }
        
    @media (max-width: $mq-max-width-tablet) {
        .img-links {
            max-height: unset;
            flex-direction: column;
            a {
                overflow: hidden;
                margin-bottom: $s2;
                max-height: $max-link-height;
            }
        }
    }
}


@media print {
    .searching-links{
        display: none;
    }
}

</style>